// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".authAdminForm_root__Yme4h {\n  width: 400px;\n  height: 920px;\n  min-height: 100vh;\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around; }\n  .authAdminForm_root__Yme4h .authAdminForm_logo__3TfEf {\n    display: flex;\n    align-items: center;\n    justify-content: center; }\n  .authAdminForm_root__Yme4h .authAdminForm_forgot__2-ePQ {\n    text-align: center;\n    display: block;\n    margin-bottom: 40px; }\n", ""]);
// Exports
exports.locals = {
	"root": "authAdminForm_root__Yme4h",
	"logo": "authAdminForm_logo__3TfEf",
	"forgot": "authAdminForm_forgot__2-ePQ"
};
module.exports = exports;
